import { render, staticRenderFns } from "./FileAttachButton.vue?vue&type=template&id=9bbef386&scoped=true&"
import script from "./FileAttachButton.vue?vue&type=script&lang=js&"
export * from "./FileAttachButton.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=9bbef386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbef386",
  null
  
)

export default component.exports